module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAAAXNSR0IB2cksfwAAACdQTFRFAAAAv7+/v7+/v7+/v7+/v7+/w8PD5+fn+/v7////v7+/6+vrv7+//YcFGQAAAA10Uk5TAFC/7/9A/////8D/8GbeifQAAAA1SURBVHicY2BUdgEBpwAGsYqZIDA9lWH1TAioYvCEsprhrCl0YPUguUBsB8xVjGvALvUKAACVolUT5Au/lAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/list-rectangle.png
// module id = 848
// module chunks = 0